import React from 'react';
import { DoubleSide, Color, MeshBasicMaterial, Vector2 } from 'three';

export const seatGeometry = <planeGeometry args={[1, 1]} />;
export const seatMaterial = <meshBasicMaterial color={new Color('white')} side={DoubleSide} />


/* UserAvatar */
export const userAvatarColor = '#aaaaaa';
export const userAvatarMaterial = <meshBasicMaterial color={userAvatarColor} />

export const userAvatarVideoHeight = 1.8;
export const userAvatarBodyHeight = 1.2;
export const userAvatarPaddingHeight = 0.5;
export const userAvatarVideoPlaneDimensions = new Vector2(1.6 * userAvatarVideoHeight / 0.9, userAvatarVideoHeight);
export const userAvatarBezelSize = 0.05;
export const userAvatarTvDepth = 0.1;

export const userAvatarBodyGeometry = <cylinderGeometry args={[0.4, 0.15, userAvatarBodyHeight, 16]}/>
export const userAvatarVideoBoxGeometry = <boxGeometry args={[userAvatarVideoPlaneDimensions.width + userAvatarBezelSize * 2, userAvatarVideoPlaneDimensions.height + userAvatarBezelSize * 2, userAvatarTvDepth]} />
export const userAvatarVideoPlaneGeometry = <planeGeometry args={[userAvatarVideoPlaneDimensions.width, userAvatarVideoPlaneDimensions.height]} />

// export const userAvatarMaterial = new MeshBasicMaterial({ color: userAvatarColor});

export const disposeSharedResources = () => {
  // React.Element objects do not need to be disposed, but Three objects do (<meshBasicMaterial /> does not, but MeshBasicMaterial does)
}
